// extracted by mini-css-extract-plugin
export default {"wrapper":"O_PlanRadio_wrapper__qTitu"};